import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLenis } from 'lenis/react'
import { SeoHead } from './seo/SeoHead'
import { SiteShell } from './components/layout/SiteShell'
import { Hero } from './components/sections/Hero/Hero'
import { About } from './components/sections/About/About'
import { Research } from './components/sections/Research/Research'
import { Publications } from './components/sections/Publications/Publications'
import { Journey } from './components/sections/Journey/Journey'
import { Contact } from './components/sections/Contact/Contacts'

/** Scrolls to /#section when arriving from another route. */
function HashScroll() {
  const { hash } = useLocation()
  const lenis = useLenis()
  useEffect(() => {
    if (!hash) return
    const t = setTimeout(() => {
      const el = document.querySelector<HTMLElement>(hash)
      if (!el) return
      if (lenis) lenis.scrollTo(el, { offset: -88, immediate: true })
      else el.scrollIntoView()
    }, 50)
    return () => clearTimeout(t)
  }, [hash, lenis])
  return null
}

export default function App() {
  return (
    <SiteShell>
      <SeoHead />
      <HashScroll />
      <Hero />
      <About />
      <Research />
      <Publications />
      <Journey />
      <Contact />
    </SiteShell>
  )
}
